module.exports = __webpack_public_path__ + "static/media/README.02d9bdbe.md";